// @flow

import * as React from 'react';
import type { Node } from 'react';
import { useState, useEffect } from 'react';
import useDeviceDetect from 'hooks/useDeviceDetect';
import Button from 'components/Button';

import { ReactComponent as Logo } from 'assets/svg/logo.svg';

import './style.scss';

export default function Component(): Node {
  const [openMenu, setOpenMenu] = useState(false);
  const { isMobile } = useDeviceDetect(); // we dont change openMenu on dektop devices

  function toggleMenuHandler() {
    setOpenMenu(!openMenu);
  }

  useEffect(() => {
    document.body.style.overflowY = openMenu ? 'hidden' : 'scroll';
  }, [openMenu]);

  return (
    <nav className="mainMenuWrapper">
      <a className="mainMenuWrapper__logo" href="/" aria-label="Go to homepage">
        <Logo />
      </a>
      <button
        aria-expanded={String(openMenu)}
        className={`hamburger ${openMenu ? 'hamburger--active' : ''}`}
        onClick={toggleMenuHandler}
      >
        <span className="sr-only">Open/Close menu</span>
        <span className="hamburger__box">
          <span className="hamburger__inner" />
        </span>
      </button>
      <div className={`navigation ${openMenu ? 'navigation--active' : ''}`}>
        <ul
          className="navigation__list ul-clear"
          onClick={isMobile && toggleMenuHandler}
          aria-hidden="true"
        >
          <li className="navigation__item">
            <Button
              isWhite
              isText
              class="item__link"
              href="https://airtable.com/shrkjCLnZoti05oTY"
              isTargetBlank
              iconFill="white"
            >
              Highlight your project
            </Button>
          </li>
          <li className="navigation__item">
            <Button isWhite isText class="item__link" to="/great-reads">
              Great reads about OSS
            </Button>
          </li>
          <li className="navigation__item">
            <Button isWhite isText class="item__link" to="/how-it-works">
              How it works
            </Button>
          </li>
          <li className="navigation__item">
            <Button secondary class="item__link" to="/side-projects">
              Side projects
            </Button>
          </li>
        </ul>
      </div>
    </nav>
  );
}
